<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row>
		<b-col>
			<b-row>
				<b-col>
					<div v-if="!$store.state.isMobile" :class="expand ? 'collapsible expanded collapsible__trafficSignalsAltered' : 'collapsible collapsible__trafficSignalsAltered collapsed'">
					<div class="collapsible-heading">
							<div class="d-flex">
							<div class="collapsible-heading__image" @click="onToggleExpand">
								<b-img v-show="!expand" src="/img/lcr/traffic-light.png" fluid></b-img>
								<b-img v-show="expand"  src="/img/lcr/light/traffic-light.png" fluid></b-img>
							</div>
							<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">Altered Traffic Signals</div>
						<div class="collapsible-heading__status" @click="onToggleExpand"><div class="w-100 flex-table"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div></div>
						<div class="collapsible-heading__toggle">
							<div class="flex-table">
								<b-button href="#" variant="collapsible"
									:class="expand ? 'flex-table-cell' : 'flex-table-cell collapsed'"
									:aria-expanded="expand ? 'true' : 'false'"
									:aria-controls="'collapseSignalListing'"
									@click="onToggleExpand"
									>
								<span class="when-opened">
								<font-awesome-icon icon="chevron-down" />
								</span>
								<span class="when-closed">
								<font-awesome-icon icon="chevron-right" />
								</span>
								</b-button>
							</div>
							</div>
							</div>
						</div>
					<b-collapse :id="'collapseSignalListing'" :visible="expand" class="collapsible-entries">
							<div :class="flexClasses(b2index)" v-if="isEntry(b2index)" v-for=" (b, b2index) in value" :key="'blta2index'+b2index+'-'+renderCounter">
								<div class="collapsible-entry__icon" v-html="getInEffectIcon(b2index)"></div>
								<div class="flex-grow-1 ">
									<div class="d-flex collapsible-entry__title-wrapper">
										<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span></a></div>
										<div class="collapsible-entry__map-button">
											<b-button class="pl-2 pr-2 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
										</div>
									</div>
								</div>
							</div>
							<div class="d-flex collapsible-entry" v-if="!hasEntries()">
								<div class="collapsible-entry__details flex-grow-1">No blocks have altered traffic signals.</div>
							</div>

					</b-collapse>
					</div>
					<!-- end of desktop -->
					<div v-if="$store.state.isMobile" :class="expand ? 'collapsible expanded collapsible__trafficSignalsAltered' : 'collapsible collapsible__trafficSignalsAltered collapsed'">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image" @click="onToggleExpand">
									<b-img src="/img/100x100/traffic-light.png" fluid></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand" v-html="getInEffectMainTitle()"></div>
								<div @click="onToggleExpand" class="collapsible-heading__effect">
									<div class="w-100 flex-table traffic-status-text"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div>
								</div>
								<div class="collapsible-heading__toggle">
									<div class="flex-table">
										<b-button href="#" variant="collapsible"
											:class="expand ? 'flex-table-cell' : 'flex-table-cell collapsed'"
											:aria-expanded="expand ? 'true' : 'false'"
											:aria-controls="'collapseSignalListing'"
											@click="onToggleExpand"
											>
										<span>
										<font-awesome-icon icon="chevron-right" />
										</span>
										</b-button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div v-if="$store.state.isMobile && expand">
						<transition  name="slide-fade" tag="div">
						<div class="d-block section-slide-panel has-menu" v-if="showPanel">
								<div class="top-controls">
									<span @click="onApply">
										<b-img src="/img/nav/icon-back.svg" alt="menu" /> Back
									</span>
								</div>
								<div class="panels-body panels-body-padded">
									<div class="panels-nav-title" v-html="getNavTitle"></div>
									<div class="panels-primary-title" v-html="getModalTitle"></div>
									<div class="d-flex lcr--restriction--legend"><div class="lcr-summary__status-legend"><img src="/img/assets/set-all-close.svg" alt="" /><span class="status-circle__label">Altered</span></div><div class="lcr-summary__status-legend"><img src="/img/assets/set-all-open.svg" alt="" /><span class="status-circle__label">Not Altered</span></div></div>
									<div class="panels-body-content">
								<div :class="flexClasses(b2index)" v-if="isEntry(b2index)" v-for=" (b, b2index) in value" :key="'blta2index'+b2index+'-'+renderCounter">
									<div class="collapsible-entry__icon pt-2" v-html="getInEffectIcon(b2index)"></div>
									<div class="flex-grow-1 ">
										<div class="d-flex collapsible-entry__title-wrapper">
											<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span></a></div>
											<div class="collapsible-entry__map-button">
												<b-button class="pl-2 pr-2 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
											</div>
										</div>
									</div>
								</div>
								<div class="d-flex collapsible-entry" v-if="!hasEntries()">
									<div class="collapsible-entry__details flex-grow-1">No blocks have altered traffic signals.</div>
								</div>

									</div>
								</div>
							</div>
						</transition>
					</div>






					<div v-if="1 == 2 && $store.state.isMobile" :class="expand ? 'collapsible expanded collapsible__trafficSignalsAltered' : 'collapsible collapsible__trafficSignalsAltered collapsed'">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image" @click="onToggleExpand">
									<!-- <b-img v-show="!expand" src="/img/lcr/traffic-light.png" fluid></b-img>
									<b-img v-show="expanded"  src="/img/lcr/light/traffic-light.png" fluid></b-img> -->
									<b-img src="/img/lcr/traffic-light.png" fluid></b-img>
								</div>
								<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">
									Altered Traffic Signals
								</div>
								<div @click="onToggleExpand" class="collapsible-heading__effect">
									<div class="w-100 flex-table traffic-status-text"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div>
								</div>
								<div class="collapsible-heading__toggle">
									<div class="flex-table">
										<b-button href="#" variant="collapsible"
											:class="expand ? 'flex-table-cell' : 'flex-table-cell collapsed'"
											:aria-expanded="expand ? 'true' : 'false'"
											:aria-controls="'collapseSignalListing'"
											@click="onToggleExpand"
											>
										<span class="when-opened">
										<font-awesome-icon icon="chevron-down" />
										</span>
										<span class="when-closed">
										<font-awesome-icon icon="chevron-right" />
										</span>
										</b-button>
									</div>
								</div>
							</div>
						</div>
						<b-collapse :id="'collapseSignalListing'" :visible="expanded" class="collapsible-entries">
								<div :class="flexClasses(b2index)" v-if="isEntry(b2index)" v-for=" (b, b2index) in value" :key="'blta2index'+b2index+'-'+renderCounter">
									<div class="collapsible-entry__icon" v-html="getInEffectIcon(b2index)"></div>
									<div class="flex-grow-1 ">
										<div class="d-flex collapsible-entry__title-wrapper">
											<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span></a></div>
											<div class="collapsible-entry__map-button">
												<b-button class="pl-2 pr-2 pt-1 pb-1" variant="text" type="button" @click="showOnMap(b.blockId)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px" /></b-button>
											</div>
										</div>
									</div>
								</div>
								<div class="d-flex collapsible-entry" v-if="!hasEntries()">
									<div class="collapsible-entry__details flex-grow-1">No blocks have altered traffic signals.</div>
								</div>

						</b-collapse>
					</div>
				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
import LaneClosureRequest from './../models/LaneClosureRequest.js'
import Vue from 'vue'

export default {
	name: 'LaneClosureRequestBlockSignalListing',
	props: ['value', 'preset','expand'],
	data() {
		return {
			isEditing: false,
			editingIndex: null,
			LaneClosureRequest: LaneClosureRequest,
			backupBlock: null,
			errorMsg: null,
			lastIndex: null,
			renderCounter:0,
			backup: {},
			showPanel: false
		}
	},
	mounted() {
		this.showPanel = this.expand;
		Vue.prototype.$bus.$on('swipe:right:panel', this.onSwipeRight);
     },
     destroyed() {
		Vue.prototype.$bus.$off('swipe:right:panel', this.onSwipeRight);
     },
	watch: {

	},
	computed: {
		getNavTitle() {
			return "More Information";
		},
		getModalTitle() {
			return "Altered Traffic Signals";
		},

	},
	methods: {
		classes: function(index) {
			if (this.isEntry(index)) {
				return "is-entry";
			} else {
				return "is-not-entry";
			}
		},
		flexClasses: function(index) {
			return "d-flex collapsible-entry";
		},
		getInEffectMainTitle() {
			var texts = [];
			if (this.value) {
				for (var index = 0; index < this.value.length; index++) {
					if (this.isEntry(index)) {
						if (texts["" + this.value[index].trafficSignalsAltered.value]) {} else {
							texts["" + this.value[index].trafficSignalsAltered.value] = 0;
						}
						texts["" + this.value[index].trafficSignalsAltered.value]++;
					}
				}
			}
			var  html = "Altered Traffic Signals";

			if (texts.length == 0) {
				html = "NOT Altering Traffic Signals";
			}
			return html;
		},
		getInEffectTitle() {
			var texts = [];
			if (this.value) {
				for (var index = 0; index < this.value.length; index++) {
					if (this.isEntry(index)) {
						if (texts["" + this.value[index].trafficSignalsAltered.value]) {} else {
							texts["" + this.value[index].trafficSignalsAltered.value] = 0;
						}
						texts["" + this.value[index].trafficSignalsAltered.value]++;
					}
				}
			}
			var html = "";
			if (texts["1"] > 0) {
				// closed
				html += "<div class='status-circle lc-closed'>" + texts["1"] + "</div>";
			}
			if (texts["0"] > 0) {
				// open
				html += "<div class='status-circle lc-open'>" + texts["0"] + "</div>";
			}
			if (texts.length == 0) {
				// html += "NOT AFFECTED";
			}
			return html;
		},
		getTitleText(uindex) {
			let title = "";
			let qty = 0;
			let total = 0;
			let found = false;
			if (this.value && this.preset) {
				for (var xx = 0; xx < this.value.length; xx++) {
					if (this.isEntry(xx)) {
						found = false;
						if (this.value[xx].trafficSignalsAltered.value == 1) {
							found = true;
						}
						if (found) {
							qty++;
						}
					}
				}
			}

			var  blockText = "blocks";
			if (total == 1) {
				blockText = "block";
			}
			if (qty > total) {
				qty = total;
			}
			if (qty == 1) {
				title = qty + " of " + total + " " + blockText;
			} else {
				if (qty == 0) {
					title = "no blocks";
				} else {
					title = qty + " of " + total + " " + blockText;
				}
			}
			return " ("+title+")";

		},

		isEntry: function(index) {
			if (this.value) {
				if (this.value[index]) {
					if (this.value[index].trafficSignalsAltered.value == 1) {
								return true;
					}
				}
			}
			return false;
		},

		hasEntries:function() {
			if (this.value) {
				for (var index = 0; index < this.value.length; index++) {
					if (this.value[index].trafficSignalsAltered.value == 1) {
								return true;
					}
				}
			}
			return false;
		},


		canBeAdded: function(index,uindex) {
			if (this.value) {
				if (this.value[index]) {
					if (this.value[index].trafficSignalsAltered.value == 1) {
								return false;
					}
				}
			}
			return true;
		},
		switchId(prefix,block) {
			return prefix+"-"+block;
		},
		shouldShowChanges(idx) {
			if (this.isEditing) {
				return true;
			}
			return false;
		},
		showOnMap: function(id) {
			Vue.prototype.$bus.$emit("block:show-on-map",{id, type: "trafficSignal", laneId: 1});
		},

		getInEffectIcon(index) {
			var texts = [];
			if (this.value) {
				if(this.isEntry(index)) {
					if (texts["" + this.value[index].trafficSignalsAltered.value]) {} else {
						texts["" + this.value[index].trafficSignalsAltered.value] = 0;
					}
					texts["" + this.value[index].trafficSignalsAltered.value]++;
				}
			}
			if (texts["null"] > 0) {
				texts["0"] = texts["0"] + texts["null"];
			}
			var html = "";
			if (texts["1"] > 0) {
				// closed
				// html += "<div class='status-circle-solid lc-closed'>&nbsp;</div>";
				html += '<img src="/img/assets/set-all-close.svg" alt="" />';
			}
			if (texts["0"] > 0) {
				// open
				// html += "<div class='status-circle-solid lc-open'>&nbsp;</div>";
				html += '<img src="/img/assets/set-all-open.svg" alt="" />';
			}

			return html;
		},

		onApply: function() {
			this.showPanel = false;
			setTimeout(() => {
				let that = this;
				Vue.prototype.$bus.$emit("block:list-expand-trafficSignalsAltered",{expand:!that.expanded});
			}, 250);
		},
		onSwipeRight() {
			if (this.showPanel) {
				this.showPanel = false;
				setTimeout(() => {
					let that = this;
					Vue.prototype.$bus.$emit("block:list-expand-trafficSignalsAltered",{expand:!that.expanded});
				}, 250);
			}
		},
		onToggleExpand: function() {
			this.renderCounter++;
			Vue.prototype.$bus.$emit("block:list-expand-trafficSignalsAltered",{expand:!this.expanded});
		},

	}
}
</script>
